import { render } from "./GroupChat.vue?vue&type=template&id=6cbef31c"
import script from "./GroupChat.vue?vue&type=script&lang=js"
export * from "./GroupChat.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omninext/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__